import { ColumnLayout, Container, Header, SpaceBetween } from '@amzn/awsui-components-console';
import { useIntl } from 'react-intl';

import { WidgetContainer } from '@/components';
import classDetailMessages from '@/containers/classPages/ClassDetailPage/ClassDetailPage.messages';

import messages from './index.messages';

import type { ProcessedClassOverviewData } from './ClassOverview.data';

interface ClassOverviewViewProps {
    data: ProcessedClassOverviewData;
}

const ClassOverviewView = ({ data }: ClassOverviewViewProps) => {
    const { formatMessage } = useIntl();

    const {
        courseTitle,
        courseVersion,
        courseLanguage,
        dateTimeRange,
        duration,
        timezone,
        deliveryType,
        classCapacity,
        instructors,
        trainingProvider,
        customers,
        activityStatus,
        lmsType,
    } = data;

    return (
        <Container
            header={<Header variant='h2'>{formatMessage(messages.classOverviewHeader)}</Header>}
        >
            <ColumnLayout columns={3} borders='vertical' variant='text-grid'>
                <SpaceBetween direction='vertical' size='m'>
                    <WidgetContainer title={formatMessage(classDetailMessages.courseTitleLabel)}>
                        {courseTitle}
                    </WidgetContainer>
                    <WidgetContainer title={formatMessage(classDetailMessages.dateLabel)}>
                        {dateTimeRange}
                    </WidgetContainer>
                    <WidgetContainer title={formatMessage(classDetailMessages.durationLabel)}>
                        {duration}
                    </WidgetContainer>
                    <WidgetContainer title={formatMessage(classDetailMessages.courseVersionLabel)}>
                        {courseVersion}
                    </WidgetContainer>
                </SpaceBetween>

                <SpaceBetween direction='vertical' size='m'>
                    <WidgetContainer title={formatMessage(classDetailMessages.courseLanguageLabel)}>
                        {courseLanguage}
                    </WidgetContainer>
                    <WidgetContainer title={formatMessage(classDetailMessages.timeZoneLabel)}>
                        {timezone}
                    </WidgetContainer>
                    <WidgetContainer title={formatMessage(messages.deliveryTypeLabel)}>
                        {deliveryType}
                    </WidgetContainer>
                    <WidgetContainer
                        title={formatMessage(classDetailMessages.classNumberOfStudents)}
                    >
                        {classCapacity}
                    </WidgetContainer>
                </SpaceBetween>

                <SpaceBetween direction='vertical' size='m'>
                    <WidgetContainer title={formatMessage(classDetailMessages.classInstructor)}>
                        {instructors.map((email) => (
                            <div key={email}>{email}</div>
                        ))}
                    </WidgetContainer>

                    {customers ? (
                        <WidgetContainer title={formatMessage(messages.customerLabel)}>
                            {customers}
                        </WidgetContainer>
                    ) : null}

                    {activityStatus ? (
                        <WidgetContainer
                            title={formatMessage(messages.learningActivityStatusLabel)}
                        >
                            {activityStatus}
                        </WidgetContainer>
                    ) : null}

                    <WidgetContainer
                        title={
                            trainingProvider.isPartner
                                ? formatMessage(classDetailMessages.trainingPartnerLabel)
                                : formatMessage(classDetailMessages.trainingProviderLabel)
                        }
                    >
                        {trainingProvider.name}
                    </WidgetContainer>
                    {lmsType ? (
                        <WidgetContainer title={formatMessage(classDetailMessages.LmsType)}>
                            {lmsType}
                        </WidgetContainer>
                    ) : null}
                </SpaceBetween>
            </ColumnLayout>
        </Container>
    );
};

export default ClassOverviewView;
